export const getSignupPathLabel = (type) => {
    if (type === 'w') return '웹'
    if (type === 'a') return '앱'

    return '-'
}

export const getSignupProviderLabel = (provider) => {
    if (provider === 'kakao') return '카카오'
    if (provider === 'naver') return '네이버'
    if (provider === 'google') return '구글'
    if (provider === 'apple') return '애플'
    if (provider === 'facebook') return '페이스북'
    if (provider === 'local') return '이메일'

    return '-'
}

export const getLastLoginDeviceLabel = (deviceType, signupType) => {
    if (signupType === 'a' && deviceType === 'web') return '미확인'
    if (deviceType === 'web') return '웹'
    if (deviceType === 'and') return 'Android'
    if (deviceType === 'ios') return 'iOS'

    return '-'
}
